import { FC } from 'react';
import { MeQuery } from 'lib/home/generated/types/api';
import { Container, Layout, LayoutProps } from 'lib/components';
import { PrivateLayout } from '../PrivateLayout/PrivateLayout';
import { Header, Loading, SideNav } from '../..';

export interface DefaultLayoutProps extends LayoutProps {
  backTo?: string | (() => void);
}

export const DefaultLayout: FC<DefaultLayoutProps> = ({ children, title, backTo, ...props }) => (
  <PrivateLayout loadingComponent={<Loading />}>
    {({ isReady, me }: { isReady: boolean; me: MeQuery['me'] }) => (
      <Layout {...props}>
        <Header backTo={backTo} />
        <div className="py-4 md:py-6 lg:py-12 xl:py-16">
          <Container>
            {title && <h2 className="m-0">{title}</h2>}
            {!isReady && <Loading />}
            {isReady && typeof children === 'function' ? children({ me }) : children}
          </Container>
        </div>
        <SideNav me={me} />
      </Layout>
    )}
  </PrivateLayout>
);
